import { API_BASE_URL } from '../config/api';
import { parseApiResponse } from './apiHelpers';

const CONTACTS_BASE = `${API_BASE_URL}/contacts`;

export const submitContactMessage = async ({ name, email, subject, message }) => {
  const res = await fetch(CONTACTS_BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, subject, message }),
  });
  return parseApiResponse(res);
};

export const fetchAllContactMessages = async (authHeaders) => {
  const res = await fetch(`${CONTACTS_BASE}/all`, { headers: authHeaders });
  const data = await parseApiResponse(res);
  return data.data;
};

export const fetchContactMessageStats = async (authHeaders) => {
  const res = await fetch(`${CONTACTS_BASE}/stats`, { headers: authHeaders });
  const data = await parseApiResponse(res);
  return data.data;
};

export const markContactMessageRead = async (messageId, authHeaders) => {
  const res = await fetch(`${CONTACTS_BASE}/${messageId}/read`, {
    method: 'PATCH',
    headers: authHeaders,
  });
  return parseApiResponse(res);
};

export const deleteContactMessage = async (messageId, authHeaders) => {
  const res = await fetch(`${CONTACTS_BASE}/${messageId}`, {
    method: 'DELETE',
    headers: authHeaders,
  });
  return parseApiResponse(res);
};
